import {
  Box,
  Button,
  Modal,
  ThemeProvider,
  createTheme,
  useMediaQuery,
} from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import ReactImagePickerEditor, {
  ImagePickerConf,
} from "react-image-uploader-fa";
import "react-image-uploader-fa/dist/index.css";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DropzoneByClick from "./DropzoneByClick";
import dataURLtoFile from "../../utility/dataURLtoFile";
import AddAPhotoIcon from "@mui/icons-material/AddAPhoto";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import CloseIcon from "@mui/icons-material/Close";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import StorefrontIcon from "@mui/icons-material/Storefront";
import { useSelector } from "react-redux";

const config: ImagePickerConf = {
  borderRadius: "5px",
  language: "fa",
  width: "35vw",
  height: "17rem",
  objectFit: "contain",
  compressInitial: null,
  widthOfImageContainer: "35vw",
};

const initialImage = "";
const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1800,
    },
  },
});

const style = (theme: any) => ({
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  [theme.breakpoints.up("xl")]: {
    // backgroundColor: "red",
    width: "60%",
    height: "80%",
  },
  [theme.breakpoints.between("lg", "xl")]: {
    // backgroundColor: "blue",
    width: "85%",
    height: "80%",
  },
  [theme.breakpoints.between("md", "lg")]: {
    // backgroundColor: "yellow",
    width: "80%",
    height: "80%",
  },
  [theme.breakpoints.down("md")]: {
    // backgroundColor: "green",
    width: "80%",
    height: "80%",
  },
  bgcolor: "white",
  boxShadow: 24,
  p: 4,
  // overflow: "auto",
  overflow: "hidden",
  paddingRight: "3vh",
  paddingTop: "5vh",
  direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
});

let mainColor: any;
export default function FileUploader({
  handleImageSubmit = () => {},
  handleOtherFiles = () => {},
  circleButtonColor = mainColor,
  fileName,
  fileTitle,
  marginRight,
  maxWidth,
  width,
  minWidth,
  fileExtensions,
  logo,
  borderClassName,
}: {
  handleImageSubmit?: Function;
  handleOtherFiles?: Function;
  circleButtonColor?: String;
  fileName?: string;
  fileTitle?: string;
  marginRight?: string;
  maxWidth?: string;
  width?: string;
  minWidth?: string;
  fileExtensions?: string[];
  logo?: string;
  borderClassName?: string;
}) {
  const jsonFile = useSelector((state: any) => state.style);

  mainColor = jsonFile?.mainColor;

  const [imageSrc, setImageSrc] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [openImageUploade, setOpenImageUploade] = useState(false);
  const [openFileUploade, setOpenFileUploade] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [showBtn, setShowBtn] = useState(true);
  const [imageSelect, setImageSelect] = useState(false);
  const inputRef = useRef<any>(null);
  const docRef = useRef<any>(null);

  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenFileUploade(false);
    setOpenImageUploade(false);
    setEditMode(false);
    setShowBtn(true);
    setImageSelect(false);
  };

  const handlOpenModal = () => {
    setOpenModal(true);
  };

  const handleAddCircleBtn = () => {
    handlOpenModal();
  };

  const imageUploadClickHandler = () => {
    setOpenFileUploade(false);
    setShowBtn(false);

    if (inputRef !== null) {
      inputRef?.current.click();
      setOpenImageUploade(true);
    }
  };

  const handleUploadDoc = () => {
    if (docRef !== null) {
      docRef?.current?.click();
    }
  };
  return (
    <>
      <ThemeProvider theme={theme}>
        <Box
          className={borderClassName ? borderClassName : "dropzoneUploadImage"}
          style={{
            minHeight: "16vh",
            cursor: "pointer",
            marginRight: marginRight ? marginRight : "1rem",
            marginLeft: "1rem",
            marginBottom: "1 .3rem",
            maxWidth: maxWidth ? maxWidth : "",
            width: width ? width : "",
            minWidth: minWidth ? minWidth : "",
          }}
          onClick={handleAddCircleBtn}
        >
          <div
            // className="uploadImage classCenter"
            className="fileuploader-modal-container"
            style={{ paddingTop: "5.5vh", marginTop: "-1.2vh" }}
          >
            {logo === "StorefrontIcon" ? (
              <StorefrontIcon
                style={{
                  color: `${jsonFile?.secondColor_200}`,
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
                className="imageuploader-editor"
              />
            ) : (
              <AddCircleIcon
                style={{
                  color: `${jsonFile?.secondColor_200}`,
                  width: "30px",
                  height: "30px",
                  cursor: "pointer",
                }}
                className="imageuploader-editor"
              />
            )}
            <br />
            <p
              className="classCenter secondColor_200"
              style={{ marginTop: "3vh", fontSize: "1rem", fontWeight: "bold" }}
            >
              {fileTitle ? (
                fileTitle
              ) : (
                <>بارگذاری &nbsp;{fileName ? fileName : "فایل"}</>
              )}
            </p>
          </div>
        </Box>
        <div className="imageUploader-modal-container">
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={[style]}>
              <Box position={"relative"}>
                <Typography
                  onClick={handleCloseModal}
                  component={"p"}
                  color={"#E6123D"}
                  position={"absolute"}
                  top={"-30px"}
                  left={0}
                  sx={{ cursor: "pointer" }}
                  fontSize={"20px"}
                >
                  <CloseIcon></CloseIcon>
                </Typography>
              </Box>
              <Box className="fileuploader-modal-container">
                <Grid
                  container
                  direction={"column"}
                  justifyContent={"center"}
                  alignItems={"center"}
                  width={"100%"}
                  paddingX={"1rem"}
                  paddingY={"2rem"}
                  // bgcolor={"#fff"}
                  marginX={"auto"}
                  height={"100%"}
                  // marginTop={{
                  //   xs: "10rem",
                  //   sm: "10rem",
                  //   md: "10rem",
                  //   lg: "5rem",
                  //   xl: "6rem",
                  // }}
                  className="fileuploader-modal-openning"
                  sx={[
                    (openFileUploade || openImageUploade) && {
                      display: "none",
                    },
                  ]}
                >
                  <Grid item>
                    <Typography
                      marginBottom={"4rem"}
                      fontSize={"20px"}
                      textAlign={"center"}
                    >
                      قصد بارگذاری چه چیزی را دارید؟
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    sx={{
                      backgroundColor: "#F1F4FF",
                      borderRadius: "5px",
                      width: "100%",
                      paddingY: "1rem",
                      paddingX: "1.5rem",
                      marginBottom: "3rem",
                      maxWidth: "650px !important",
                    }}
                  >
                    <Typography
                      color={"#1D4A87"}
                      fontSize={"14px"}
                      marginBottom={"0.7rem"}
                    >
                      .در صورت وجود حاشیه در اطراف محتوای اصلی، تصویر را ویرایش
                      و سپس ارسال نمایید
                      <WarningAmberIcon
                        sx={{ marginLeft: "0.5rem" }}
                      ></WarningAmberIcon>
                    </Typography>
                    <Typography color={"#1D4A87"} fontSize={"14px"}>
                      .و ... خود را از طریق دکمه "بارگذاری فایل" ارسال نمایید
                      PDF و Word فایل های غیر از تصویر مثل
                    </Typography>
                  </Grid>
                  <Grid
                    container
                    justifyContent={"center"}
                    alignItems={"center"}
                    gap={"1rem"}
                    direction={{
                      xl: "row",
                      lg: "row",
                      md: "column",
                      sm: "column",
                      xs: "column",
                    }}
                  >
                    <Grid item>
                      <Button
                        className="dropzone-button"
                        sx={[
                          {
                            cursor: "pointer",
                            padding: "1rem",
                            marginY: "1rem",
                            backgroundColor: "#01AF43",
                            color: "#fff !important",
                            borderRadius: "5px",
                            width: "20vw !important",
                            height: "46px !important",
                            fontWeight: "900 !important",
                            fontSize: "13px !important",
                          },
                        ]}
                        onClick={handleUploadDoc}
                      >
                        بارگذاری فایل
                        <PictureAsPdfIcon
                          sx={{ marginLeft: "0.5rem" }}
                        ></PictureAsPdfIcon>
                      </Button>
                    </Grid>
                    <Grid item>
                      <Typography
                        textAlign={"center"}
                        width={"20vw"}
                        height={"46px"}
                        component={"p"}
                        sx={[
                          {
                            cursor: "pointer",
                            padding: "1rem",
                            // paddingX: "5rem",
                            marginY: "1rem",
                            backgroundColor: "#01AF43",
                            color: "#fff",
                            borderRadius: "5px",
                            fontWeight: "900",
                          },
                        ]}
                        onClick={imageUploadClickHandler}
                      >
                        بارگذاری و ویرایش عکس
                        <AddAPhotoIcon
                          sx={{ marginLeft: "0.5rem" }}
                        ></AddAPhotoIcon>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  direction="column"
                  justifyContent={"center"}
                  alignItems={"center"}
                  // width={"40%"}
                  // paddingBottom={"2rem"}
                  bgcolor={"#fff"}
                  marginX={"auto"}
                  height={"100%"}
                  // marginTop={"9rem"}
                  sx={[
                    showBtn && {
                      display: "none",
                    },
                  ]}
                >
                  <Grid item className="fileuploader-modal-container">
                    <Box
                      sx={[!openImageUploade && { display: "none" }]}
                      className={!editMode ? "imageuploader-editor" : ""}
                    >
                      <ReactImagePickerEditor
                        config={config}
                        imageSrcProp={initialImage}
                        imageChanged={(newDataUri: any) => {
                          setImageSrc(newDataUri);
                        }}
                        imageDownloaded={(e: any) => {
                          handleImageSubmit(
                            dataURLtoFile(e.imageSrc, e.imageTitle)
                          );
                          handleCloseModal();
                        }}
                        imagePanelOpen={() => {
                          setEditMode(true);
                          setImageSelect(true);
                        }}
                        imagePanelClose={() => {
                          setEditMode(false);
                        }}
                        imageSelected={() => setImageSelect(true)}
                        inputRef={inputRef}
                        imageDeleted={() => setImageSelect(false)}
                      />
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Modal>
        </div>
        {/* <DropzoneByClick
          size={20}
          picName={"تصویر مدرک"}
          onFileChoosed={(e: any) => {
            handleOtherFiles(e);
            handleCloseModal();
          }}
          inputRef={docRef}
          fileExtensions={fileExtensions}
        /> */}
      </ThemeProvider>
    </>
  );
}
